// Polyfills for browser compatibility
if (typeof process === 'undefined') {
  window.process = {
    env: {
      NODE_ENV: 'development',
      REACT_APP_APPINSIGHTS_KEY: '',
      REACT_APP_API_URL: 'http://localhost/api'
    },
    browser: true,
    version: '',
    versions: {},
    platform: 'browser',
    nextTick: function(fn) { setTimeout(fn, 0); },
    cwd: function() { return '/'; },
    chdir: function() {},
    umask: function() { return 0; },
    hrtime: function() { return [0, 0]; },
    exit: function() {},
    kill: function() {},
    abort: function() {},
    on: function() {},
    addListener: function() {},
    once: function() {},
    removeListener: function() {},
    removeAllListeners: function() {},
    emit: function() {},
    prependListener: function() {},
    prependOnceListener: function() {},
    listeners: function() { return []; },
    binding: function() {},
    cwd: function() { return '/'; },
    chdir: function() {},
    umask: function() { return 0; },
    hrtime: function() { return [0, 0]; },
    exit: function() {},
    kill: function() {},
    abort: function() {},
    on: function() {},
    addListener: function() {},
    once: function() {},
    removeListener: function() {},
    removeAllListeners: function() {},
    emit: function() {},
    prependListener: function() {},
    prependOnceListener: function() {},
    listeners: function() { return []; },
    binding: function() {}
  };
}

if (typeof global === 'undefined') {
  window.global = window;
}

// Make sure process is available globally
if (typeof global !== 'undefined') {
  global.process = window.process;
}
